__turbopack_context__.v({
  "Table": "Table-module-scss-module__hZl6SG__Table",
});
